/*@flow*/
import gql from 'graphql-tag';

import type { DocumentNode } from 'graphql';
export default (gql(`
  query GetLayers($theGeom: String, $bbox: String) {
    layers(theGeom: $theGeom, bbox: $bbox) {
      id
      uuid
      type
      name
      sql
      query
      interactivity
      collection
      layergroup
      cartocss
      userName
      labelKeys
      fieldLabels
      legendType
      legendMarkup
      legendColor
      legendDotType
      legendDotStyle
      colorDomain
      colorRange
      order
    }
  }
`): DocumentNode);
